module.exports = __webpack_public_path__ + "static/BT_trapapp-50d466e9b9d5be1290180e7a02b4a935.png";